export default __webpack_public_path__ + "static/media/blackHolder.b007a250.jpg";